/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M22.9718 2.3375a1.4682 1.4682 0 0 0 .2782-.8592C23.25.6618 22.5814 0 21.7565 0H2.2435a1.504 1.504 0 0 0-.868.2754l-.1457.1171c-.5456.4979-.644 1.3317-.2015 1.945l7.9833 10.5047.0015 9.6792c0 .2295.054.4559.1577.6611.3689.7302 1.266 1.0262 2.0037.6611l2.7579-2.115a2.0362 2.0362 0 0 0 .0684-.0439c.6114-.4086.9862-1.0949.9862-1.8375l-.0015-7.002 7.9863-10.5077Z"
    clipRule="evenodd"
  />,
  'FiltersFilled'
);
